/* Desktop gallery thumbnail strip — horizontal wheel/trackpad scrolling.
   The strip is a freeMode Swiper, but Minimog's Swiper build omits the Mousewheel
   module, so wheel/trackpad gestures don't move it. This translates a
   predominantly-HORIZONTAL wheel delta (Apple trackpad two-finger swipe / Magic
   Mouse) into Swiper translate. Vertical wheel is left alone so the page still
   scrolls when the pointer is over the thumbnails. (Click-drag already works via
   Swiper's simulateTouch.) */
(function () {
  function getSwiper(strip) {
    if (strip.swiper) return strip.swiper;
    var el = strip.classList.contains('swiper') ? strip
           : strip.querySelector('.swiper, [class*="swiper-container"]');
    if (el && el.swiper) return el.swiper;
    var n = strip.querySelectorAll('*');
    for (var i = 0; i < n.length; i++) if (n[i].swiper) return n[i].swiper;
    return null;
  }
  document.addEventListener('wheel', function (e) {
    var strip = e.target && e.target.closest
      ? e.target.closest('.m-product-media--slider__thumbnails') : null;
    if (!strip) return;
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   // horizontal gestures only
    var sw = getSwiper(strip);
    if (!sw || typeof sw.setTranslate !== 'function') return;
    var min = sw.minTranslate(), max = sw.maxTranslate();
    if (min <= max) return;                                 // fits — nothing to scroll
    e.preventDefault();
    var dx = e.deltaX * (e.deltaMode === 1 ? 16 : 1);
    if (sw.setTransition) sw.setTransition(0);
    var next = Math.min(min, Math.max(max, sw.translate - dx));
    sw.setTranslate(next);
    if (sw.updateProgress) sw.updateProgress();
    if (sw.updateActiveIndex) sw.updateActiveIndex();
    if (sw.updateSlidesClasses) sw.updateSlidesClasses();
  }, { passive: false });
})();
